import { useState, useEffect, useRef, useCallback } from 'react';
import Axios from 'axios';
import DOMPurify from 'dompurify';
import HTMLReactParse from 'html-react-parser';
import logo from '../../assets/img/full-logo.png';
import vialidadLogo from '../../assets/img/MSTD SIG - LogoVialidad.jpeg';
import { MapContainer, useMap, useMapEvent, WMSTileLayer, LayersControl, Popup } from 'react-leaflet';
import { useParams } from 'react-router-dom';
import MapInfo from "./MapInfo";
import MapIndicators from "./MapIndicators";
import Footer from "../Layout/Footer";
import Button from 'react-bootstrap/Button';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';

let CancelToken = Axios.CancelToken;
let source = CancelToken.source();

// const baseAPIUrl = "http://localhost:8080";
const baseAPIUrl = "https://geoserverp.mstdlab.com";
const mapsApiKey = "AIzaSyByR5k-sHik49bsUIaxHF6Kph5DqyiyXfY";

const sigProjectsData = [
  {
    title: 'Estudio de Movilidad Sustentable Comuna de La Unión 12-24',
    mapZoom: 14,
    mapCenter: [-40.291638, -73.079596],
    mapMaxBounds: [[-40.329749, -73.141994],[-40.255700, -73.008368]],
    data: {
      imgmosaic: { name: 'Mosaico', layername: 'imgmosaic', workspace: 'launion1224' },
      legendLayer: { layername: 'AutoLegendLayersGroup', workspace: 'launion1224v2'},
      layers: [
        {name: 'Área - Área La Union', layername: 'Area La Union', workspace: 'launion1224v2'},
        {name: 'Área - Catálogo La Unión', layername: 'Catalogo La Union', workspace: 'launion1224v2'},
        {name: 'Construcciones - Altura Edificaciones', layername: 'Altura_Edificaciones', workspace: 'launion1224v2'},
        {name: 'Construcciones - Edificaciones', layername: 'Edificaciones', workspace: 'launion1224v2'},
        {name: 'Construcciones - Estacionamientos', layername: 'Estacionamientos', workspace: 'launion1224v2'},
        {name: 'Construcciones - Invernaderos', layername: 'Invernaderos', workspace: 'launion1224v2'},
        {name: 'Construcciones - Silos', layername: 'Silos', workspace: 'launion1224v2'},
        {name: 'Construcciones - Subestaciones Eléctricas', layername: 'Subestaciones_Electricas', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Bancos', layername: 'Bancos', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Bencineras', layername: 'Bencinera', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Bomberos', layername: 'Bomberos', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Canchas', layername: 'Canchas', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Carabineros', layername: 'Carabineros', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Cementerio', layername: 'Cementerio', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Central Hidroeléctrica', layername: 'central_Hidroelectrica', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Centro Médico', layername: 'Centro_Medico', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Colegios', layername: 'Colegios', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Escuelas', layername: 'Escuelas', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Estadios', layername: 'Estadios', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Fábricas', layername: 'Fabricas', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Ferreterías', layername: 'Ferreteria', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Gimnasios', layername: 'Gimnasio', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Hospitales', layername: 'Hospital', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Iglesias', layername: 'Iglesias', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Institutos', layername: 'Instituto', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Jardín Infantil', layername: 'Jardin_Infantil', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Juzgado de Letras', layername: 'Juzgado_de_Letras', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Liceos', layername: 'Liceo', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Municipalidad', layername: 'Municipalidad', workspace: 'launion1224v2'},
        {name: 'Equipamiento - OMIL', layername: 'OMIL', workspace: 'launion1224v2'},
        {name: 'Equipamiento - PDI', layername: 'PDI', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Piscinas', layername: 'Piscina', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Registro Civil', layername: 'Registro_civil', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Seremi', layername: 'Seremi', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Supermercados', layername: 'Supermercados', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Terminal de Buses', layername: 'Terminal_de_Buses', workspace: 'launion1224v2'},
        {name: 'Pendientes - Pendientes 0-5', layername: 'pendientes_0-5', workspace: 'launion1224v2'},
        {name: 'Pendientes - Pendientes 5-30', layername: 'pendientes_30-o_mas', workspace: 'launion1224v2'},
        {name: 'Pendientes - Pendientes 30 o más', layername: 'pendientes_5-30', workspace: 'launion1224v2'},
        {name: 'Predios - Linea de Cierre', layername: 'Linea_de_Cierre', workspace: 'launion1224v2'},
        {name: 'Predios - Linea de Edificacion', layername: 'Linea_de_Edificacion', workspace: 'launion1224v2'},
        {name: 'Predios - Manzanas', layername: 'Manzanas', workspace: 'launion1224v2'},
        {name: 'Predios - Predio Agrícola', layername: 'Predio_Agricola', workspace: 'launion1224v2'},
        {name: 'Predios - Subdivisión Predial', layername: 'Subdivision_Predial', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Acequia', layername: 'Acequia', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Canales', layername: 'Canales', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Estero', layername: 'Estero', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Laguna', layername: 'Laguna', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Lecho', layername: 'Lecho', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Quebradas', layername: 'Quebradas', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Río', layername: 'Rio', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Tranque', layername: 'Tranque', workspace: 'launion1224v2'},
        {name: 'Servicios - Antenas', layername: 'Antena', workspace: 'launion1224v2'},
        {name: 'Servicios - Base Torre Alta Tensión', layername: 'Base Torre Alta Tensión', workspace: 'launion1224v2'},
        {name: 'Servicios - Camaras', layername: 'Camaras', workspace: 'launion1224v2'},
        {name: 'Servicios - Copa de agua', layername: 'Copa de agua', workspace: 'launion1224v2'},
        {name: 'Servicios - Línea Eléctrica Alta Tensión', layername: 'Linea Electrica Alta Tensión', workspace: 'launion1224v2'},
        {name: 'Servicios - Línea Eléctrica Baja Tensión', layername: 'Lineas Electricas baja tension', workspace: 'launion1224v2'},
        {name: 'Servicios - Luminarias', layername: 'Luminarias', workspace: 'launion1224v2'},
        {name: 'Servicios - Postes', layername: 'Postes', workspace: 'launion1224v2'},
        {name: 'Servicios - Sumideros', layername: 'Sumideros', workspace: 'launion1224v2'},
        {name: 'Servicios - Torres Alta Tensión', layername: 'Torres_Alta_Tension', workspace: 'launion1224v2'},
        {name: 'Topografía - Cota Topográfica', layername: 'Cota_Topografica', workspace: 'launion1224v2'},
        {name: 'Topografía - Curvas de Nivel Indice', layername: 'Curvas de Nivel Indice', workspace: 'launion1224v2'},
        {name: 'Topografía - Curvas de Nivel Intermedias', layername: 'Curvas de Nivel Intermedias', workspace: 'launion1224v2'},
        {name: 'Topografía - Excavaciones', layername: 'Excavaciones', workspace: 'launion1224v2'},
        {name: 'Varios - Letreros', layername: 'Letreros', workspace: 'launion1224v2'},
        {name: 'Varios - Tuberías', layername: 'Tuberia', workspace: 'launion1224v2'},
        {name: 'Varios - Zanjas', layername: 'Zanja', workspace: 'launion1224v2'},
        {name: 'Varios - Zona de Amortiguamiento', layername: 'zona de Amortiguamiento', workspace: 'launion1224v2'},
        {name: 'Vegetación - Arbol Común', layername: 'Arbol_Comun', workspace: 'launion1224v2'},
        {name: 'Vegetación - Arbol Grande', layername: 'Arbol_Grande', workspace: 'launion1224v2'},
        {name: 'Vegetación - Áreas Verdes', layername: 'Areas_Verdes', workspace: 'launion1224v2'},
        {name: 'Vegetación - Espacio Publico', layername: 'Espacio Publico', workspace: 'launion1224v2'},
        {name: 'Vegetación - Paisajismo', layername: 'Paisajismo', workspace: 'launion1224v2'},
        {name: 'Vegetación - Palmeras', layername: 'Palmeras', workspace: 'launion1224v2'},
        {name: 'Vegetación - Plaza', layername: 'Plaza', workspace: 'launion1224v2'},
        {name: 'Vegetación - Sitios Eriazos', layername: 'Sitios_Eriazos', workspace: 'launion1224v2'},
        {name: 'Vialidad - Aceras', layername: 'Aceras', workspace: 'launion1224v2'},
        {name: 'Vialidad - Barreras de Contención', layername: 'Barreras_de_Contencion', workspace: 'launion1224v2'},
        {name: 'Vialidad - Berma', layername: 'Berma', workspace: 'launion1224v2'},
        {name: 'Vialidad - Calzada Asfalto', layername: 'Calzada_Asfalto', workspace: 'launion1224v2'},
        {name: 'Vialidad - Calzada Hormigón', layername: 'Calzada_Hormigon', workspace: 'launion1224v2'},
        {name: 'Vialidad - Calzada Tierra', layername: 'Calzada_Tierra', workspace: 'launion1224v2'},
        {name: 'Vialidad - Ciclovía', layername: 'Ciclovia', workspace: 'launion1224v2'},
        {name: 'Vialidad - Cotas Intersecciónes Calles', layername: 'Cotas_Intersecciones_Calles', workspace: 'launion1224v2'},
        {name: 'Vialidad - Cruces Peatonales', layername: 'Cruces_Peatonales', workspace: 'launion1224v2'},
        {name: 'Vialidad - Ejes', layername: 'Ejes', workspace: 'launion1224v2'},
        {name: 'Vialidad - Linea Férrea', layername: 'Linea_Ferrea', workspace: 'launion1224v2'},
        {name: 'Vialidad - Linea de Solera', layername: 'Linea_de_Solera', workspace: 'launion1224v2'},
        {name: 'Vialidad - Obras de Arte', layername: 'Obra de arte', workspace: 'launion1224v2'},
        {name: 'Vialidad - Paradero', layername: 'Paradero', workspace: 'launion1224v2'},
        {name: 'Vialidad - Pasarela', layername: 'Pasarela', workspace: 'launion1224v2'},
        {name: 'Vialidad - Paso bajo nivel', layername: 'Paso_bajo_nivel', workspace: 'launion1224v2'},
        {name: 'Vialidad - Puente', layername: 'Puente', workspace: 'launion1224v2'},
        {name: 'Vialidad - Puente Ferroviario', layername: 'Puente_Ferroviario', workspace: 'launion1224v2'},
        {name: 'Vialidad - Puente Peatonal', layername: 'Puente_Peatonal', workspace: 'launion1224v2'},
        {name: 'Vialidad - Refugio de Parada', layername: 'Refugio_de_Parada', workspace: 'launion1224v2'},
        {name: 'Vialidad - Rotonda', layername: 'Rotonda', workspace: 'launion1224v2'},
        {name: 'Vialidad - Semáforos', layername: 'Semaforos', workspace: 'launion1224v2'},
        {name: 'Vialidad - Veredas', layername: 'Veredas', workspace: 'launion1224v2'}
      ]
    }
  },
  {
    title: 'Estudio de Movilidad Sustentable Comuna de Santa Juana',
    mapZoom: 15,
    mapCenter: [-37.175007670133716, -72.948041371231],
    mapMaxBounds: [[-37.199843, -72.984753],[-37.149645, -72.906990]],
    data: {
      imgmosaic: { name: 'Mosaico', layername: 'imgmosaic', workspace: 'stajuana0325' },
      legendLayer: { layername: 'AutoLegendLayersGroup', workspace: 'stajuana0325'},
      layers: [
        {name: 'Construcciones - Altura Edificaciones', layername: 'Altura Edificaciones', workspace: 'stajuana0325'},
        {name: 'Construcciones - Edificaciones', layername: 'Edificaciones', workspace: 'stajuana0325'},
        {name: 'Construcciones - Estacionamientos', layername: 'Estacionamientos', workspace: 'stajuana0325'},
        {name: 'Construcciones - Invernaderos', layername: 'Invernaderos', workspace: 'stajuana0325'},
        {name: 'Construcciones - Silos', layername: 'Silos', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Colegios', layername: 'Colegios', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Cuarteles Policiales', layername: 'Cuartel_policial', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Cuarteles de Bomberos', layername: 'Cuarteles_de_bomberos', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Ferreterías', layername: 'Ferreteria', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Hospitales', layername: 'Hospital', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Iglesias', layername: 'Iglesia', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Jardínes Infantiles', layername: 'Jardines_Infantiles', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Piscinas', layername: 'Piscina', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Restaurantes', layername: 'Restaurantes', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Salas Cuna', layername: 'Sala_Cuna', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Supermercados y Minimarkets', layername: 'Supermercado_y_Minimarket', workspace: 'stajuana0325'},
        {name: 'Predios - Linea de Cierre', layername: 'Linea_Cierre', workspace: 'stajuana0325'},
        {name: 'Predios - Linea de Edificacion', layername: 'Linea_Edificacion', workspace: 'stajuana0325'},
        {name: 'Predios - Manzanas', layername: 'Manzanas', workspace: 'stajuana0325'},
        {name: 'Predios - Predio Agrícola', layername: 'Predio Agricola', workspace: 'stajuana0325'},
        {name: 'Predios - Predios', layername: 'Predios', workspace: 'stajuana0325'},
        {name: 'Predios - Subdivisión Predial', layername: 'Subdivision Predial', workspace: 'stajuana0325'},
        {name: 'Puntos de Control', layername: 'Puntos_de_Control', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Canales', layername: 'Canales', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Estero', layername: 'Estero', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Laguna', layername: 'Laguna', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Lecho Río', layername: 'Lecho Rio', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Obras de Arte', layername: 'Obras de Arte', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Puente', layername: 'Puente', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Río', layername: 'Rio', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Tranque', layername: 'Tranque', workspace: 'stajuana0325'},
        {name: 'Servicios - Antenas', layername: 'Antenas', workspace: 'stajuana0325'},
        {name: 'Servicios - Camaras', layername: 'Camaras', workspace: 'stajuana0325'},
        {name: 'Servicios - Canchas', layername: 'Canchas', workspace: 'stajuana0325'},
        {name: 'Servicios - Cementerio', layername: 'Cementerio', workspace: 'stajuana0325'},
        {name: 'Servicios - Copa de agua', layername: 'Copa de agua', workspace: 'stajuana0325'},
        {name: 'Servicios - Estanques', layername: 'Estanques', workspace: 'stajuana0325'},
        {name: 'Servicios - Grifos', layername: 'Grifos', workspace: 'stajuana0325'},
        {name: 'Servicios - Línea Baja Tensión', layername: 'Linea Baja Tension', workspace: 'stajuana0325'},
        {name: 'Servicios - Línea Media Tensión', layername: 'Linea Media Tension', workspace: 'stajuana0325'},
        {name: 'Servicios - Luminarias', layername: 'Luminarias', workspace: 'stajuana0325'},
        {name: 'Servicios - Postes', layername: 'Postes', workspace: 'stajuana0325'},
        {name: 'Servicios - Sumideros', layername: 'Sumideros', workspace: 'stajuana0325'},
        {name: 'Topografía - Cotas Topográficas', layername: 'Cotas Topograficas', workspace: 'stajuana0325'},
        {name: 'Topografía - Curvas de Nivel Indice', layername: 'Curvas de Nivel Indice', workspace: 'stajuana0325'},
        {name: 'Topografía - Curvas de Nivel Intermedias', layername: 'Curvas de Nivel Intermedias', workspace: 'stajuana0325'},
        {name: 'Varios - Letreros Publicitarios', layername: 'Letreros Publicitarios', workspace: 'stajuana0325'},
        {name: 'Vegetación - Arbol Común', layername: 'Arbol Comun', workspace: 'stajuana0325'},
        {name: 'Vegetación - Arboles Grandes', layername: 'Arboles Grandes', workspace: 'stajuana0325'},
        {name: 'Vegetación - Áreas Verdes', layername: 'Areas Verdes', workspace: 'stajuana0325'},
        {name: 'Vegetación - Masa Arborea', layername: 'Masa Arborea', workspace: 'stajuana0325'},
        {name: 'Vegetación - Palmeras', layername: 'Palmeras', workspace: 'stajuana0325'},
        {name: 'Vegetación - Plazas', layername: 'Plazas', workspace: 'stajuana0325'},
        {name: 'Vegetación - Sitios Eriazos', layername: 'Sitios Eriazos', workspace: 'stajuana0325'},
        {name: 'Vegetación - Terrenos de Cultivo', layername: 'Terrenos de Cultivo', workspace: 'stajuana0325'},
        {name: 'Vialidad - Aceras', layername: 'Acera', workspace: 'stajuana0325'},
        {name: 'Vialidad - Barreras', layername: 'Barreras', workspace: 'stajuana0325'},
        {name: 'Vialidad - Bermas', layername: 'Bermas', workspace: 'stajuana0325'},
        {name: 'Vialidad - Calzadas Asfalto', layername: 'Calzadas Asfalto', workspace: 'stajuana0325'},
        {name: 'Vialidad - Calzadas Hormigón', layername: 'Calzadas Hormigon', workspace: 'stajuana0325'},
        {name: 'Vialidad - Calzadas Tierra', layername: 'Calzadas Tierra', workspace: 'stajuana0325'},
        {name: 'Vialidad - Ciclovías', layername: 'Ciclovias', workspace: 'stajuana0325'},
        {name: 'Vialidad - Cota Intersección Calles', layername: 'Cota Interseccion calles', workspace: 'stajuana0325'},
        {name: 'Vialidad - Cruces Peatonales', layername: 'Cruces peatonales', workspace: 'stajuana0325'},
        {name: 'Vialidad - Ejes', layername: 'Ejes', workspace: 'stajuana0325'},
        {name: 'Vialidad - Muelle', layername: 'Muelle', workspace: 'stajuana0325'},
        {name: 'Vialidad - Obras de Arte', layername: 'Obras de Arte (Vialidad)', workspace: 'stajuana0325'},
        {name: 'Vialidad - Paraderos', layername: 'Paraderos', workspace: 'stajuana0325'},
        {name: 'Vialidad - Puente', layername: 'Puente (Vialidad)', workspace: 'stajuana0325'},
        {name: 'Vialidad - Refugio Paraderos', layername: 'Refugio Paraderos', workspace: 'stajuana0325'},
        {name: 'Vialidad - Resalto', layername: 'Resalto', workspace: 'stajuana0325'},
        {name: 'Vialidad - Solera', layername: 'Solera', workspace: 'stajuana0325'},
        {name: 'Vialidad - Veredas', layername: 'Veredas', workspace: 'stajuana0325'}
      ]
    }
  },
  {
    title: 'Estudio de Movilidad Sustentable Comuna de San Carlos',
    mapZoom: 14,
    mapCenter: [-36.425288,-71.956673],
    mapMaxBounds: [[-36.483969,-72.054520],[-36.372369,-71.866379]],
    data: {
      imgmosaic: { name: 'Mosaico', layername: 'imgmosaic', workspace: 'sancarlos0725' },
      legendLayer: { layername: 'AutoLegendLayersGroup', workspace: 'sancarlos0725'},
      layers: [
        {name: 'Area - Area', layername: 'Area', workspace: 'sancarlos0725'},
        {name: 'Area - Catalogo', layername: 'Catalogo', workspace: 'sancarlos0725'},
        {name: 'Construcciones - Alturas Edificaciones', layername: 'Alturas Edificaciones', workspace: 'sancarlos0725'},
        {name: 'Construcciones - Edificaciones', layername: 'Edificaciones', workspace: 'sancarlos0725'},
        {name: 'Construcciones - Estacionamientos', layername: 'Estacionamientos', workspace: 'sancarlos0725'},
        {name: 'Construcciones - Invernaderos', layername: 'Invernaderos', workspace: 'sancarlos0725'},
        {name: 'Construcciones - Media_Luna', layername: 'Media_Luna', workspace: 'sancarlos0725'},
        {name: 'Construcciones - Plaza_Peaje', layername: 'Plaza_Peaje', workspace: 'sancarlos0725'},
        {name: 'Construcciones - Silos', layername: 'Silos', workspace: 'sancarlos0725'},
        {name: 'Construcciones - Subestacion_electrica', layername: 'Subestacion_electrica', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Bancos', layername: 'Bancos', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Bencinera', layername: 'Bencinera', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Bomberos', layername: 'Bomberos', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Canchas', layername: 'Canchas', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Carabineros', layername: 'Carabineros', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Cementerio', layername: 'Cementerio', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Centros_Medicos', layername: 'Centros_Medicos', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Colegios', layername: 'Colegios', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Estadio', layername: 'Estadio', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Ferreterias', layername: 'Ferreterias', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Gimnasios', layername: 'Gimnasios', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Hospital', layername: 'Hospital', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Iglesias', layername: 'Iglesias', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Instituto', layername: 'Instituto', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Jardin_Infantil', layername: 'Jardin_Infantil', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Juzgado_de_Letras', layername: 'Juzgado_de_Letras', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Liceos', layername: 'Liceos', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Municipalidad', layername: 'Municipalidad', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - OMIL', layername: 'OMIL', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - PDI', layername: 'PDI', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Piscina_Municipal', layername: 'Piscina_Municipal', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Registro_Civil', layername: 'Registro_Civil', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Supermercado', layername: 'Supermercado', workspace: 'sancarlos0725'},
        {name: 'Equipamiento - Terminal_de_Buses', layername: 'Terminal_de_Buses', workspace: 'sancarlos0725'},
        {name: 'Predios - Linea de cierre', layername: 'Linea de cierre', workspace: 'sancarlos0725'},
        {name: 'Predios - Linea de Edificacion', layername: 'Linea de Edificacion', workspace: 'sancarlos0725'},
        {name: 'Predios - Manzanas', layername: 'Manzanas', workspace: 'sancarlos0725'},
        {name: 'Predios - Predio Agricola', layername: 'Predio Agricola', workspace: 'sancarlos0725'},
        {name: 'Predios - Subdivision Predial', layername: 'Subdivision Predial', workspace: 'sancarlos0725'},
        {name: 'Red Hidrológica - Acequia', layername: 'Acequia', workspace: 'sancarlos0725'},
        {name: 'Red Hidrológica - Canal', layername: 'Canal', workspace: 'sancarlos0725'},
        {name: 'Red Hidrológica - Estero', layername: 'Estero', workspace: 'sancarlos0725'},
        {name: 'Red Hidrológica - Laguna - Lago', layername: 'Laguna - Lago', workspace: 'sancarlos0725'},
        {name: 'Red Hidrológica - Lecho', layername: 'Lecho', workspace: 'sancarlos0725'},
        {name: 'Red Hidrológica - Rio', layername: 'Rio', workspace: 'sancarlos0725'},
        {name: 'Red Hidrológica - Tranques', layername: 'Tranques', workspace: 'sancarlos0725'},
        {name: 'Servicios - Antena', layername: 'Antena', workspace: 'sancarlos0725'},
        {name: 'Servicios - Camara Cuadrada', layername: 'Camara Cuadrada', workspace: 'sancarlos0725'},
        {name: 'Servicios - Camara Redonda', layername: 'Camara Redonda', workspace: 'sancarlos0725'},
        {name: 'Servicios - Copa de Agua', layername: 'Copa de Agua', workspace: 'sancarlos0725'},
        {name: 'Servicios - Linea Electrica Baja Tension', layername: 'Linea Electrica Baja Tension', workspace: 'sancarlos0725'},
        {name: 'Servicios - Linea Electrica Media Tension', layername: 'Linea Electrica Media Tension', workspace: 'sancarlos0725'},
        {name: 'Servicios - Luminarias', layername: 'Luminarias', workspace: 'sancarlos0725'},
        {name: 'Servicios - Postes', layername: 'Postes', workspace: 'sancarlos0725'},
        {name: 'Servicios - Sumidero', layername: 'Sumidero', workspace: 'sancarlos0725'},
        {name: 'Topografía - Cota Topografica', layername: 'Cota Topografica', workspace: 'sancarlos0725'},
        {name: 'Topografía - Curvas de Nivel Indice', layername: 'Curvas de Nivel Indice', workspace: 'sancarlos0725'},
        {name: 'Topografía - Curvas de Nivel Intermedias', layername: 'Curvas de Nivel Intermedias', workspace: 'sancarlos0725'},
        {name: 'Topografía - Proteccion Talud Enrocado', layername: 'Proteccion Talud Enrocado', workspace: 'sancarlos0725'},
        {name: 'Topografía - Terraplenes', layername: 'Terraplenes', workspace: 'sancarlos0725'},
        {name: 'Varios - Eje_Vereda', layername: 'Eje_Vereda', workspace: 'sancarlos0725'},
        {name: 'Varios - Ejes_Tipo_Camino', layername: 'Ejes_Tipo_Camino', workspace: 'sancarlos0725'},
        {name: 'Varios - Espacio Publico', layername: 'Espacio Publico', workspace: 'sancarlos0725'},
        {name: 'Varios - Letrero Publicitario', layername: 'Letrero Publicitario', workspace: 'sancarlos0725'},
        {name: 'Varios - Tuberia', layername: 'Tuberia', workspace: 'sancarlos0725'},
        {name: 'Vegetación - Arbol Comun', layername: 'Arbol Comun', workspace: 'sancarlos0725'},
        {name: 'Vegetación - Arbol Grande', layername: 'Arbol Grande', workspace: 'sancarlos0725'},
        {name: 'Vegetación - Area Verde', layername: 'Area Verde', workspace: 'sancarlos0725'},
        {name: 'Vegetación - Paisajismo', layername: 'Paisajismo', workspace: 'sancarlos0725'},
        {name: 'Vegetación - Palmera', layername: 'Palmera', workspace: 'sancarlos0725'},
        {name: 'Vegetación - Plazas', layername: 'Plazas', workspace: 'sancarlos0725'},
        {name: 'Vegetación - Sitios Eriazos', layername: 'Sitios Eriazos', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Aceras', layername: 'Aceras', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Barrera_contencion', layername: 'Barrera_contencion', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Berma', layername: 'Berma', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Calzada de Adoquin', layername: 'Calzada de Adoquin', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Calzada de Asfalto', layername: 'Calzada de Asfalto', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Calzada de Hormigon', layername: 'Calzada de Hormigon', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Calzada de Tierra', layername: 'Calzada de Tierra', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Ciclovia', layername: 'Ciclovia', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Cota Interseccion Calles', layername: 'Cota Interseccion Calles', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Cruce Peatonal', layername: 'Cruce Peatonal', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Cruces Peatonales', layername: 'Cruces Peatonales', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Ejes Viales', layername: 'Ejes Viales', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Linea Ferrea', layername: 'Linea Ferrea', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Mediana', layername: 'Mediana', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Mediana_Linea', layername: 'Mediana_Linea', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Obra de arte', layername: 'Obra de arte', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Paraderos', layername: 'Paraderos', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Pasarela Peatonales', layername: 'Pasarela Peatonales', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Paso Bajo Nivel', layername: 'Paso Bajo Nivel', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Paso Sobre Nivel', layername: 'Paso Sobre Nivel', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Puente ferroviario', layername: 'Puente ferroviario', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Puentes', layername: 'Puentes', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Refugio de Paraderos', layername: 'Refugio de Paraderos', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Semaforo', layername: 'Semaforo', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Soleras', layername: 'Soleras', workspace: 'sancarlos0725'},
        {name: 'Vialidad - Veredas', layername: 'Veredas', workspace: 'sancarlos0725'}
      ]
    }
  }
]

const Map2 = () => {

  const [loading, setLoading] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isIndicatorsModalOpen, setIsIndicatorsModalOpen] = useState(false);
  const [dataPosToUse, setDataPosToUse] = useState(-1);
  const [showLegend, setShowLegend] = useState(false);

  let { projectCode } = useParams();
  
  const isFirstRender = useRef(true);

  useEffect(() => {
    document.title = "MSTD SIG";
  }, []);

  const LocationMarker = () => {
    const [position, setPosition] = useState(null)
    const [featureData, setFeatureData] = useState(null)

    const map = useMap()
    
    const mapEvent = useMapEvent('click', (e) => {
      let activeLayers = [];
      for (const layerKey in e.target._layers) {
        if (e?.target?._layers?.[layerKey]?.options?.layers) {
          if (!e.target._layers[layerKey].options.layers.includes('imgmosaic')) {
            activeLayers.push(e.target._layers[layerKey].options.layers)
          }
        }
      }

      if (activeLayers.length) {
        if (source) {
          source.cancel();
          source = CancelToken.source();
        }

        const featureInfoReqData = {
          workspace: sigProjectsData[dataPosToUse].data.imgmosaic.workspace,
          bbox: map.getBounds().toBBoxString(),
          point: { x: Math.round(e.containerPoint.x), y: Math.round(e.containerPoint.y) },
          layers: activeLayers,
          width: e.target._size.x,
          height: e.target._size.y,
          featureCount: 50
        }
    
        const opts = { cancelToken: source.token };
        let url = '/api/projects/featureInfo';
    
        Axios.post(url, featureInfoReqData, opts)
        .then((res) => {
          const cleanHTML = DOMPurify.sanitize(res.data, { USE_PROFILES: { html: true } });
          const parsedHTML = HTMLReactParse(cleanHTML);
          setPosition(e.latlng)
          setFeatureData(parsedHTML);
        })
        .catch((err) => {
          console.log(err?.response?.data);
          console.log(err);
        });
      }
    });

    if (position && featureData) {
      return (
        <Popup position={position}>
          <div className="">
            {featureData}
          </div>
        </Popup>
      )
    } else {
      return null
    }
  }

  // const GetData = useCallback(() => {
  //   setLoading(true);

  //   if (source) {
  //     source.cancel();
  //     source = CancelToken.source();
  //   }

  //   const opts = { cancelToken: source.token };

  //   // const url = '/api/projects/create/colors/aaa';
  //   // const url = '/api/projects/create/legend/aaa';
  //   const url = '/api/projects/initial';

  //   Axios.get(url, opts)
  //   .then((res) => {
  //     setLoading(false);
  //     console.log(res.data);
  //   })
  //   .catch((err) => {
  //     setLoading(false);
  //     // if (Axios.isCancel(err)) {
  //     //   alert.show('Petición cancelada', {type: 'info'});
  //     // } else if (!err.response) {
  //     //   console.log('Petición cancelada');
  //     // } else if (err.response.status === 500) {
  //     //   alert.show('No se recibió respuesta del servidor', {type: 'error'})
  //     // } else {
  //     //   alert.show(err.response.data.msg, {type: 'error'})
  //     // }
  //   });
  // }, []);

  // useEffect(() => {
  //   if(isFirstRender.current){
  //     GetData();
  //   }
  // }, [GetData]);

  const RenderLegendTooltip = useCallback(() => {
    if (dataPosToUse > -1) {      
      const imgSrc = baseAPIUrl+"/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=18&HEIGHT=18&LAYER="+
        sigProjectsData[dataPosToUse].data.legendLayer.workspace+':'+sigProjectsData[dataPosToUse].data.legendLayer.layername+
        "&LEGEND_OPTIONS=layout:horizontal;fontSize:11"
      return (
        <div className="flex-column position-absolute" style={{ top: 125, left: 10, bottom: 0, zIndex: 3, display: (showLegend ? "flex" : "none") }}>
          <div className="p-2 border border-2 border-solid bg-white overflow-auto">
            <img src={imgSrc} alt="Leyenda" style={{ objectFit: 'contain' }} />
          </div>
        </div>
      )
    } else {
      return null;
    }
  }, [dataPosToUse, showLegend])

  useEffect(() => {
    if (projectCode) {
      if (projectCode === "La Unión 12-24") {
        setDataPosToUse(0);
      } else if (projectCode === "Santa Juana 03-25") {
        setDataPosToUse(1);
      } else if (projectCode === "San Carlos 07-25") {
        setDataPosToUse(2);
      }
    }
  }, [projectCode]);
  
  return (
    <>
      <MapInfo isOpen={isInfoModalOpen} projectCode={projectCode} dataPosToUse={dataPosToUse} closeModal={() => setIsInfoModalOpen(false)} />
      <MapIndicators isOpen={isIndicatorsModalOpen} projectCode={projectCode} dataPosToUse={dataPosToUse} closeModal={() => setIsIndicatorsModalOpen(false)} />
      <div className="d-flex flex-column flex-1 h-100">
        <div className="d-flex justify-content-between mx-3 mx-md-5 mt-3">
          <div className="d-flex flex-md-row flex-column align-items-center">
            <div className="d-flex flex-1 align-self-center justify-content-center py-1" >
              <img className="cursor-pointer" style={{ height: '50px' }} src={logo} alt="MSTD"/> 
            </div>
          </div>
          <div className="d-flex align-items-center mx-2">
            { dataPosToUse === 1 ? 
              <div>
                <img style={{ height: '50px' }} src={vialidadLogo} alt="Vialidad"/> 
              </div>
            : null }
            <p className="h4 ms-2 mb-0">{((dataPosToUse > -1) ? sigProjectsData[dataPosToUse].title : 'MSTD SIG')}</p>
          </div>
          <div className="d-flex flex-md-row flex-column align-items-center justify-content-around justify-content-md-center">
            {/* <Button variant="primary" onClick={() => GetData()}>
              ToApi
            </Button> */}
            <Button variant="primary" onClick={() => setIsInfoModalOpen(true)}>
              Información
            </Button>
            <Button variant="primary" className="ms-md-2" onClick={() => setIsIndicatorsModalOpen(true)}>
              Indicadores
            </Button>
          </div>
        </div>
        { (dataPosToUse > -1) ? 
            <div className="d-flex flex-column flex-1 position-relative m-3 h-100 border border-2">
              <Button onClick={() => setShowLegend(!showLegend)} style={{ position: 'absolute', top: 90, left: 10, zIndex: 3 }}>
                Leyenda
              </Button>
              {RenderLegendTooltip()}
              <MapContainer 
                className="bg-white" 
                center={sigProjectsData[dataPosToUse].mapCenter} 
                zoom={sigProjectsData[dataPosToUse].mapZoom} 
                minZoom={13} 
                bounds={sigProjectsData[dataPosToUse].mapMaxBounds} 
                maxBounds={sigProjectsData[dataPosToUse].mapMaxBounds} 
                maxBoundsViscosity={1} 
                scrollWheelZoom 
                zoomSnap={0.2}
                zoomDelta={0.2}
                id="map" 
              >
                <ReactLeafletGoogleLayer apiKey={mapsApiKey} type={'satellite'} />
                <LayersControl position="topright">
                  <LayersControl.Overlay checked name={sigProjectsData[dataPosToUse].data.imgmosaic.name}>
                    <WMSTileLayer
                      url={baseAPIUrl+"/geoserver/"+sigProjectsData[dataPosToUse].data.imgmosaic.workspace+"/wms"}
                      params={{ 
                        format:"image/png", 
                        layers: (sigProjectsData[dataPosToUse].data.imgmosaic.workspace + ':' + sigProjectsData[dataPosToUse].data.imgmosaic.layername), 
                        transparent: true, 
                        maxZoom: 25, 
                        maxNativeZoom: 25 
                      }}
                    />
                  </LayersControl.Overlay>
                  {sigProjectsData[dataPosToUse].data.layers.map((raster, index) => (
                    <LayersControl.Overlay 
                    name={raster.name} 
                    key={index}>
                      <WMSTileLayer
                        url={baseAPIUrl+"/geoserver/"+raster.workspace+"/wms"}
                        params={{ 
                          format:"image/png", 
                          layers: (raster.workspace + ':' + raster.layername), 
                          transparent: true, 
                          maxZoom: 25, 
                          maxNativeZoom: 25 
                        }}
                      />
                    </LayersControl.Overlay>
                  ))}
                </LayersControl>
                <LocationMarker />
              </MapContainer>
            </div>
        : null }
      </div>
      <Footer />
    </>
  )
}

export default Map2;